/** Named z-index values */
export var layer = {
    contextLoading: 800,
    appFeedback: 700,
    modal: 600,
    contextFeedback: 500,
    appNavigation: 400,
    contextNavigation: 300,
    fixedContent: 200,
    content: 100,
    first: 1,
    negative: -1
};
//# sourceMappingURL=layer.js.map